module.exports = __webpack_public_path__ + "img/icon-inventario.527acbbb.svg";